import React, { Fragment, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';
import numeral from 'numeral';
import moment from 'moment';

import PerfectScrollbar from 'react-perfect-scrollbar';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    KeyboardTimePicker,
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Card,
    CardContent,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Avatar,
    Icon,
    Tooltip,
    IconButton,
    TableFooter
} from '@material-ui/core';

import agm from '../../services/agm'
import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
    },
    input: {
        color: colors.cyan['A700']
    },
    container: {
        maxHeight: 460,
    },
    indice: {
        fontSize: 12,
        color: colors.green[600],
        marginTop: '-10px'
    }
}));

import { IoIosCalculator } from "react-icons/io";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

const Billing = ({ item, open, closeEdition, updateValues, dependencies }) => {

    const classes = useStyles();

    const [orcamento, setOrcamento] = useState({});
    const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [sumario, setSumario] = useState({ total1: 0.0, total2: 0.0, total3: 0.0 })

    const openDeletion = async (orcamento, values) => {
        setOrcamento({ orcamento: orcamento, lote: values });
        setMessage({
            title: 'Lote de Faturamento',
            message: 'Confirma a remoção do orçamento selecionado?',
            warn: 'Esta ação não poderá ser cancelada. O orçamento voltará para Fase de "Orçamento Aprovado" e será removido deste Lote.'
        });
        setOpenDeletionDialog(true);
    }

    const closeDeletion = () => {
        setOpenDeletionDialog(false);
    };

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const getItensCount = (values, budgets) => {
        var valor = 0.0;
        var valor1 = 0.0;
        var valor2 = 0.0;
        for (var index = 0; index < budgets.length; index++) {
            const orcamento = budgets[index];
            var v1 = parseFloat((orcamento.valorMaoObra) ? orcamento.valorMaoObra : 0.0);
            var v2 = parseFloat((orcamento.valorMaterial) ? orcamento.valorMaterial : 0.0);
            valor = valor + (v1 + v2);
            valor1 = (valor1 + v1);
            valor2 = (valor2 + v2);
        }
        sumario.total1 = valor1;
        sumario.total2 = valor2;
        sumario.total3 = valor;
        values.valorTotal = valor;
        values.qtdOrcamentos = budgets.length;
        return budgets.length;
    }

    const deleteValues = (item) => {
        agm.post('/faturamento/orcamento/', {
            orcamento: item.orcamento,
            lote: item.lote,
            usuario: localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname'),
            justificativa: 'Remoção do Orçamento do Lote ' + item.lote.codigo + ' pelo usuário',
        }, {}).then(async (response) => {
            if (!response.data.error) {
                for (let index = 0; index < dependencies.budgets.length; index++) {
                    const orcamento = dependencies.budgets[index];
                    if (orcamento.id == item.orcamento.id) {
                        dependencies.budgets.splice(index, 1);
                    }
                }
                var valor = 0.0;
                var valor1 = 0.0;
                var valor2 = 0.0;
                for (let index = 0; index < dependencies.budgets.length; index++) {
                    const orcamento = dependencies.budgets[index];
                    var v1 = parseFloat((orcamento.valorMaoObra) ? orcamento.valorMaoObra : 0.0);
                    var v2 = parseFloat((orcamento.valorMaterial) ? orcamento.valorMaterial : 0.0);
                    valor = valor + (v1 + v2);
                    valor1 = (valor1 + v1);
                    valor2 = (valor2 + v2);
                }
                setSumario({ itens: dependencies.budgets.length, total1: valor1, total2: valor2, total3: valor });
                item.lote.valorTotal = valor;
                item.lote.qtdOrcamentos = dependencies.budgets.length;
            }
            closeDeletion();
            setMessage(response.data);
            setOpenAlert(true);
        }).catch((error) => {
            closeDeletion();
            setMessage({
                error: true,
                message: error.message,
                detail: error.message
            });
            setOpenAlert(true);
        })
    };

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Confirmations item={orcamento}
                message={message}
                open={openDeletionDialog}
                close={closeDeletion}
                confirmation={deleteValues} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Lote de Faturamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                codigo: Yup.string().max(20).required('É obrigatório informar o código'),
                                dataCriacao: Yup.string().required('É obrigatório informar a data de criação'),
                                status: Yup.string().max(20).required('A seleção do status é obrigatório'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Box className={classes.fieldset} mt={1} >

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <NumberFormat
                                                error={Boolean(touched.codigo && errors.codigo)}
                                                fullWidth
                                                label="Código"
                                                margin="none"
                                                name="codigo"
                                                id="codigo"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.codigo}
                                                variant="outlined"
                                                customInput={TextField}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={7}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.nome && errors.nome)}
                                                fullWidth
                                                label="Descrição"
                                                margin="none"
                                                name="nome"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.nome}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataCriacao"
                                                label="Data de Criação"
                                                format="DD/MM/YYYY"
                                                name="dataCriacao"
                                                value={values.dataCriacao}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataCriacao", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink htmlFor="STS_LOTE">Status</InputLabel>
                                                <Select notched
                                                    required
                                                    autosize={true}
                                                    error={Boolean(touched.STS_LOTE && errors.STS_LOTE)}
                                                    helperText={touched.STS_LOTE && errors.STS_LOTE}
                                                    value={values.STS_LOTE}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Status"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'STS_LOTE',
                                                        id: 'STS_LOTE',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.statuslist.map((status) => (
                                                        <MenuItem key={status.id} value={status.id}>{status.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>


                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataEnvio"
                                                label="Data de Envio"
                                                format="DD/MM/YYYY"
                                                name="dataEnvio"
                                                value={values.dataEnvio}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataEnvio", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required={values.STS_LOTE == 4}
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataFechamento"
                                                label="Data de Fechamento"
                                                format="DD/MM/YYYY"
                                                name="dataFechamento"
                                                value={values.dataFechamento}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataFechamento", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataPrevisao"
                                                label="Precisão de recebimento"
                                                format="DD/MM/YYYY"
                                                name="dataPrevisao"
                                                value={values.dataPrevisao}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataPrevisao", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <Card>
                                                <CardContent>

                                                    <Grid container
                                                        direction="row"
                                                        justify="flex-start"
                                                        alignItems="center"
                                                        spacing={1}  >

                                                        <Grid item
                                                            md={12}
                                                            xs={12}>

                                                            <TableContainer component={PerfectScrollbar} className={classes.container}>

                                                                <Table stickyHeader size="small" aria-label="a dense table" >
                                                                    <TableHead>

                                                                        <TableRow>

                                                                            <TableCell>
                                                                                Ocorrência
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Orçamento
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Data Orçamento
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Mão Obra
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Material
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Total
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Fase Orçamento
                                                                            </TableCell>

                                                                            <TableCell width={10} >
                                                                            </TableCell>

                                                                        </TableRow>

                                                                    </TableHead>

                                                                    <TableBody>
                                                                        {dependencies.budgets.map((orc, index) => (
                                                                            <TableRow
                                                                                hover
                                                                                key={orc.id}
                                                                            >
                                                                                <TableCell>
                                                                                    <Box
                                                                                        alignItems="center"
                                                                                        display="flex"
                                                                                    >
                                                                                        <Typography className={classes.indice}>
                                                                                            {numeral(index + 1).format("00")}
                                                                                        </Typography>
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={IoIosCalculator} style={{ color: colors.green[600] }} ></Icon>}
                                                                                        </Avatar>
                                                                                        {orc.ocorrencia.numero}
                                                                                    </Box>
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    {numeral(orc.numero).format('000000')}
                                                                                </TableCell>

                                                                                <TableCell align="center">
                                                                                    {moment(orc.dataCricao).format('DD/MM/YYYY')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(orc.valorMaoObra).format('0.00').replace('.', ',')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(orc.valorMaterial).format('0.00').replace('.', ',')}
                                                                                </TableCell>

                                                                                <TableCell align="right" className={classes.input} >
                                                                                    {numeral(orc.valorMaoObra + orc.valorMaterial - orc.valorDesconto).format('0.00').replace('.', ',')}
                                                                                </TableCell>

                                                                                <TableCell >
                                                                                    {orc.fase.nome}
                                                                                </TableCell>

                                                                                <TableCell >
                                                                                    <Tooltip title="Excluir Produto">
                                                                                        <IconButton
                                                                                            disabled={values.STS_LOTE == 4}
                                                                                            color="secondary"
                                                                                            className={classes.btntreatment}
                                                                                            children={<DeleteRoundedIcon />}
                                                                                            size="medium"
                                                                                            onClick={() => { openDeletion(orc, values) }}>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        ))
                                                                        }


                                                                    </TableBody>

                                                                    <TableFooter>
                                                                        <TableRow>
                                                                            <TableCell align="left" >
                                                                                {numeral(getItensCount(values, dependencies.budgets)).format('00')} Itens
                                                                            </TableCell>

                                                                            <TableCell align="right" colSpan={2}>
                                                                            </TableCell>

                                                                            <TableCell align="right" >
                                                                                {numeral(sumario.total1).format('0.00')}
                                                                            </TableCell>

                                                                            <TableCell align="right" >
                                                                                {numeral(sumario.total2).format('0.00')}
                                                                            </TableCell>


                                                                            <TableCell align="right" className={classes.input}>
                                                                                {numeral(sumario.total3).format('0.00')}
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                            </TableCell>

                                                                        </TableRow>

                                                                    </TableFooter>

                                                                </Table>
                                                            </TableContainer>

                                                        </Grid>

                                                    </Grid>

                                                </CardContent>
                                            </Card>
                                        </Grid>

                                    </Grid>


                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent >

            </Dialog >

        </Fragment >
    );
};

export default Billing;
